import React from 'react'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { ROLE } from '../auth'
import { PrivateRoute } from '../auth/PrivateRoute'
import { Employees } from './routes/Employees'
import { Requisites } from './routes/Requisites'
import { PushAndSms } from './routes/PushAndSms'
import { ExternalUserFlags } from './routes/ExternalUserFlags'
import ExternalTransactionsPage from './routes/ExternalTransactions'
import { RiskScoreLogs } from './routes/RiskScoreLogs'
import { AuditPage } from './routes/Audit'

export const Logs: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path='/employees'
          element={
            <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
              <Employees />
            </PrivateRoute>
          }
        />
        <Route
          path='/requisites'
          element={
            <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
              <Requisites />
            </PrivateRoute>
          }
        />
        <Route
          path='/push-and-sms'
          element={
            <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
              <PushAndSms />
            </PrivateRoute>
          }
        />

        <Route
          path='/external-user-flags'
          element={
            <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
              <ExternalUserFlags />
            </PrivateRoute>
          }
        />

        

        <Route index element={<Navigate to='/employees' />} />

        <Route path='/external-transactions/*' element={<ExternalTransactionsPage />} />

        <Route
          path='/audit'
          element={
            <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
              <AuditPage />
            </PrivateRoute>
          }
        />

        <Route
          path='/risk-score'
          element={
            <PrivateRoute
              roles={[
                ROLE.ROLE_ADMIN,
                ROLE.ROLE_MANAGER,
                ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
                ROLE.ROLE_MERCHANT_MANAGER,
              ]}
            >
              <RiskScoreLogs />
            </PrivateRoute>
          }
        />
      </Route>
    </Routes>
  )
}
